export const SET_ITEMS = 'SET_ITEMS';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_CRITERE_RECHERCHE = 'SET_CRITERE_RECHERCHE';
export const SET_PRODUITS = 'SET_PRODUITS';
export const SET_REGROUPEMENT_PRODUIT = 'SET_REGROUPEMENT_PRODUIT';
